export default __webpack_public_path__ + "KaTeX_Caligraphic-Bold.0c96bc8fe7861c576cfee97fd1af3b2d.ttf";